import { bff } from '@/lib/http/bff';

export type WorkflowDataCleanupFilters = {
  worker_key?: string;
  system?: string;
  handler_key_base?: string;
  handler_namespace?: string;
  scope_namespace?: string;
  scope_key?: string;
};

export type WorkflowDataCleanupTargets = {
  runs?: boolean;
  steps?: boolean;
  executions?: boolean;
  outcomes?: boolean;
  run_outcomes?: boolean;
  scopes?: boolean;
};

export type WorkflowDataCleanupCounts = {
  runs: number;
  steps: number;
  executions: number;
  outcomes: number;
  run_outcomes: number;
  scopes: number;
};

export type WorkflowDataCleanupResponse = {
  dry_run: boolean;
  tenant_id: number;
  filters: WorkflowDataCleanupFilters;
  requested_targets: Required<WorkflowDataCleanupTargets>;
  effective_targets: Required<WorkflowDataCleanupTargets>;
  matched: WorkflowDataCleanupCounts;
  deleted: WorkflowDataCleanupCounts;
  /** GCS URIs discovered during dry-run (only present when dry_run=true). */
  gcs_uris?: string[];
};

export type WorkflowDataCleanupRequest = {
  dry_run: boolean;
  filters: WorkflowDataCleanupFilters;
  targets: WorkflowDataCleanupTargets;
  tenant_id?: number;
};

export const workflowDataCleanupApi = (body: WorkflowDataCleanupRequest): Promise<WorkflowDataCleanupResponse> =>
  bff.post<WorkflowDataCleanupResponse>('/orchestrator/cleanup/workflow-data', body as any);

export type HandlerEventsCleanupRequest = {
  dry_run: boolean;
  handler_key: string;
};

export type HandlerEventsCleanupResponse = {
  dry_run: boolean;
  tenant_id: number;
  handler_key: string;
  matched: number;
  deleted: number;
};

export const handlerEventsCleanupApi = (body: HandlerEventsCleanupRequest): Promise<HandlerEventsCleanupResponse> =>
  bff.post<HandlerEventsCleanupResponse>('/orchestrator/cleanup/handler-events', body as any);

export type WorkerEventsCleanupRequest = {
  dry_run: boolean;
  worker_key: string;
};

export type WorkerEventsCleanupResponse = {
  dry_run: boolean;
  tenant_id: number;
  worker_key: string;
  matched: number;
  deleted: number;
};

export const workerEventsCleanupApi = (body: WorkerEventsCleanupRequest): Promise<WorkerEventsCleanupResponse> =>
  bff.post<WorkerEventsCleanupResponse>('/orchestrator/cleanup/worker-events', body as any);

/* ── GCS bulk-delete ─────────────────────────────────────────── */

export type GcsDeleteResponse = {
  ok: boolean;
  deleted: string[];
  failed: { uri: string; error: string }[];
  skipped: string[];
};

export const gcsDeleteApi = (uris: string[]): Promise<GcsDeleteResponse> =>
  bff.post<GcsDeleteResponse>('/gcs/delete', { uris } as any);
